import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

export default ['$q', 'JsonRPCService', function ($q, JsonRPCService) {
    var capabilityPrefix = ApplicationFeatures.getAllFeatures().gatewayendorsement === 'true' ? 'gateway' : '';

    return {
        loadEndorsement: function loadEndorsement(policyNumber) {
            return JsonRPCService.send('pc', capabilityPrefix + 'policychange/policychange', 'load', [policyNumber]);
        },

        loadEndorsementWithEffectiveDate: function loadEndorsementWithEffectiveDate(policyNumber, effectiveDate) {
            return JsonRPCService.send('pc', capabilityPrefix + 'policychange/policychange', 'loadWithEffectiveDate', [policyNumber, effectiveDate]);
        },

        saveEndorsement: function saveEndorsement(endorsement) {
            endorsement.beforeSave();
            return JsonRPCService.send('pc', capabilityPrefix + 'policychange/policychange', 'save', [endorsement]);
        },

        updateCoverages: function updateCoverages(jobID, lobCoverages) {
            return JsonRPCService.send('pc', capabilityPrefix + 'policychange/policychange', 'updateCoverages', [jobID, lobCoverages]);
        },

        quoteEndorsement: function quoteEndorsement(jobNumber) {
            return JsonRPCService.send('pc', capabilityPrefix + 'policychange/policychange', 'quote', [jobNumber]);
        },

        bind: function bind(jobNumber, paymentDetails) {
            return JsonRPCService.send('pc', capabilityPrefix + 'policychange/policychange', 'bind', [jobNumber, paymentDetails]);
        },

        withdrawEndorsement: function withdrawEndorsement(jobNumber) {
            return JsonRPCService.send('pc', capabilityPrefix + 'policychange/policychange', 'withdraw', [jobNumber]);
        },

        getAvailablePolicy: function getAvailablePolicy(policyNumber) {
            return JsonRPCService.send('pc', capabilityPrefix + 'policychange/policychange', 'getAvailablePolicy', [policyNumber]);
        },

        getAvailablePolicies: function getAvailablePolicies() {
            return JsonRPCService.send('pc', capabilityPrefix + 'policychange/policychange', 'getAvailablePolicies', []);
        },

        getPolicyBillingSummary: function getPolicyBillingSummary(policyNumber) {
            return JsonRPCService.send('bc', capabilityPrefix + 'billing/billingData', 'getPolicyBillingSummary', [policyNumber]);
        },

        checkEffectiveDateIsValid: function checkEffectiveDateIsValid(policyNumber, date) {
            return JsonRPCService.send('pc', capabilityPrefix + 'policychange/policychange', 'checkEffectiveDateIsValid', [policyNumber, date]);
        },

        isQuoted: function isQuoted(jobNumber) {
            return JsonRPCService.send('pc', capabilityPrefix + 'policychange/policychange', 'isQuoted', [jobNumber]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/endorsement/common/services/EndorsementService.js
// module id = 1451
// module chunks = 0